module.exports = __webpack_public_path__ + "static/media/amda_logo.346c8940.svg";